/**
 * Подписи доменных значений. Магазин умеет настраивать свои подписи статусов —
 * они приезжают в `StoreInfo.statusLabels` и перекрывают эти; тут запас,
 * чтобы интерфейс никогда не показывал сырой `awaiting_pickup`.
 */
export const LOCALES = ['uk', 'ru'];
export const DEFAULT_LOCALE = 'uk';
export const ORDER_STATUS_LABELS = {
    uk: {
        pending: 'Очікує оплату',
        processing: 'Обробка',
        on_hold: 'На утриманні',
        shipped: 'Відправлено',
        awaiting_pickup: 'Очікує отримання',
        completed: 'Завершено',
        cancelled: 'Скасовано',
        refunded: 'Повернено',
        failed: 'Невдало',
    },
    ru: {
        pending: 'Ожидает оплату',
        processing: 'Обработка',
        on_hold: 'На удержании',
        shipped: 'Отправлено',
        awaiting_pickup: 'Ожидает получения',
        completed: 'Завершён',
        cancelled: 'Отменён',
        refunded: 'Возвращён',
        failed: 'Неудачно',
    },
};
export const ORDER_STATUS_GROUP_LABELS = {
    uk: { active: 'В роботі', shipping: 'В дорозі', done: 'Виконані', problem: 'Проблемні' },
    ru: { active: 'В работе', shipping: 'В пути', done: 'Выполненные', problem: 'Проблемные' },
};
export const PAYMENT_METHOD_LABELS = {
    uk: {
        cod: 'Накладений платіж',
        card: 'Картка',
        crypto: 'Криптовалюта',
        bank: 'Банківський переказ',
        cash: 'Готівка',
        other: 'Інше',
    },
    ru: {
        cod: 'Наложенный платёж',
        card: 'Карта',
        crypto: 'Криптовалюта',
        bank: 'Банковский перевод',
        cash: 'Наличные',
        other: 'Другое',
    },
};
export const PAYMENT_STATUS_LABELS = {
    uk: {
        unpaid: 'Не оплачено',
        pending: 'Очікує оплати',
        partial: 'Часткова оплата',
        paid: 'Оплачено',
        failed: 'Оплата не пройшла',
        refunded: 'Повернено',
    },
    ru: {
        unpaid: 'Не оплачен',
        pending: 'Ожидает оплаты',
        partial: 'Частичная оплата',
        paid: 'Оплачен',
        failed: 'Оплата не прошла',
        refunded: 'Возвращён',
    },
};
export const DELIVERY_METHOD_LABELS = {
    uk: {
        novaposhta: 'Нова пошта',
        meest: 'Meest',
        courier: 'Курʼєр',
        pickup: 'Самовивіз',
        other: 'Інше',
    },
    ru: {
        novaposhta: 'Новая почта',
        meest: 'Meest',
        courier: 'Курьер',
        pickup: 'Самовывоз',
        other: 'Другое',
    },
};
export const CASHBACK_TYPE_LABELS = {
    uk: {
        registration_bonus: 'Бонус за реєстрацію',
        review_bonus: 'За відгук',
        order_cashback: 'Кешбек за замовлення',
        admin_bonus: 'Нарахував менеджер',
        bonus_used: 'Списання бонусів',
        other: 'Інше',
    },
    ru: {
        registration_bonus: 'Бонус за регистрацию',
        review_bonus: 'За отзыв',
        order_cashback: 'Кешбек за заказ',
        admin_bonus: 'Начислил менеджер',
        bonus_used: 'Списание бонусов',
        other: 'Другое',
    },
};
/**
 * Цвет статуса — токен нашей палитры, а не hex: светлая и тёмная темы
 * подставляют разные значения.
 */
export const ORDER_STATUS_TONE = {
    pending: 'amber',
    processing: 'blue',
    on_hold: 'violet',
    shipped: 'cyan',
    awaiting_pickup: 'violet',
    completed: 'green',
    cancelled: 'gray',
    refunded: 'red',
    failed: 'red',
};
export function orderStatusLabel(status, locale = DEFAULT_LOCALE, overrides) {
    return overrides?.[status] ?? ORDER_STATUS_LABELS[locale][status];
}
//# sourceMappingURL=labels.js.map